module.exports = __webpack_public_path__ + "img/shadow.5ad7ae66.png";